import { Button, ButtonProps, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, PaperProps } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export type DialogModalProps = {
  title: string;
  isOpen: boolean;
  closeModal: () => void;
  handleConfirm?: (() => void) | null;
  confirmButtonText?: string;
  confirmButtonProps?: Partial<ButtonProps>;
  closeOnConfirm?: boolean;
  cancelButtonText?: string;
  children: ReactNode;
  dialogProps?: any;
  paperProps?: Partial<PaperProps>;
  showButtons?: boolean;
  hideCancelButton?: boolean;
};

export const DialogModal = ({
  isOpen,
  closeModal,
  handleConfirm,
  confirmButtonText,
  confirmButtonProps = {},
  closeOnConfirm = true,
  cancelButtonText,
  children,
  dialogProps = {},
  paperProps = {},
  title,
  showButtons = true,
  hideCancelButton = false,
}: DialogModalProps) => {
  const { t } = useTranslation();

  const onConfirm = () => {
    handleConfirm?.();

    if (closeOnConfirm) {
      closeModal();
    }
  };

  return (
    <Dialog
      data-testid="confirmation-dialog"
      open={isOpen}
      onClose={closeModal}
      maxWidth="lg"
      PaperProps={{ style: { width: 600 }, ...paperProps }}
      {...dialogProps}
    >
      <DialogTitle variant="h5">{title}</DialogTitle>
      <Divider sx={{ width: '100%' }} />
      <DialogContent sx={{ p: 3, whiteSpace: 'pre-line' }}>{children}</DialogContent>
      <Divider sx={{ width: '100%' }} />
      {showButtons && (
        <DialogActions>
          <Grid container justifyContent="flex-end" gap={3}>
            {!hideCancelButton && (
              <Button color="tertiary" data-testid="dialog-cancel-button" onClick={closeModal}>
                {cancelButtonText || t('components:form.cancel')}
              </Button>
            )}
            <Button data-testid="dialog-confirm-button" onClick={onConfirm} {...confirmButtonProps}>
              {confirmButtonText || t('components:form.confirm')}
            </Button>
          </Grid>
        </DialogActions>
      )}
    </Dialog>
  );
};
